import { render } from "./ProfileView.vue?vue&type=template&id=9b5d1188&scoped=true&ts=true"
import script from "./ProfileView.vue?vue&type=script&lang=ts"
export * from "./ProfileView.vue?vue&type=script&lang=ts"

import "./ProfileView.vue?vue&type=style&index=0&id=9b5d1188&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b5d1188"]])

export default __exports__